import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Notification, SvgIcon, Portal, } from '@integration-app/react';
import clsx from 'clsx';
import { PropertiesPortal } from './Properties';
import { SchemaBuilderRowContextProvider, useSchemaBuilderRowContext, } from './row-context';
import classes from './Row.module.css';
function RowRoot({ children, className, embedded }) {
    return (_jsx(SchemaBuilderRowContextProvider, { children: _jsxs("div", { className: clsx(classes.rowWrapper, embedded && classes.rowWrapperEmbedded), children: [_jsx("div", { className: clsx(classes.row, embedded && classes.rowEmbedded, className), children: children }), _jsx(PropertiesPortal, {})] }) }));
}
const RowProperties = forwardRef(({ children, className, expanded, ...props }, ref) => {
    const { propertiesRef } = useSchemaBuilderRowContext();
    return (_jsx(Portal, { node: propertiesRef, children: _jsx("div", { className: clsx(classes.rowProperties, expanded && classes.rowPropertiesExpanded, className), ...props, ref: ref, children: children }) }));
});
RowProperties.displayName = 'RowProperties';
export const Row = Object.assign(RowRoot, {
    Properties: RowProperties,
});
const CellRoot = forwardRef(({ children, disabled, grow, shrink, width, className, ...props }, ref) => {
    const style = width ? { flexBasis: width } : undefined;
    return (_jsx("div", { className: clsx(classes.cell, grow && classes.cellGrow, shrink && classes.cellShrink, disabled && classes.cellDisabled, className), "aria-disabled": disabled, "aria-readonly": disabled, style: style, ...props, ref: ref, children: children }));
});
CellRoot.displayName = 'CellRoot';
const CellName = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx(Cell, { className: clsx(classes.cellName, className), ...props, ref: ref, children: children }));
});
CellName.displayName = 'CellName';
const CellCombobox = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx(Cell, { className: clsx(classes.cellCombobox, className), ...props, ref: ref, children: children }));
});
CellCombobox.displayName = 'CellCombobox';
const CellInput = forwardRef(({ children, className, ...props }, ref) => {
    return (_jsx(Cell, { className: clsx(classes.cellInput, className), ...props, ref: ref, children: children }));
});
CellInput.displayName = 'CellInput';
const CellIcon = forwardRef(({ type, className, ...props }, ref) => {
    return (_jsx(Cell, { className: clsx(classes.cellIcon, className), ...props, ref: ref, children: _jsx(SvgIcon, { type: type }) }));
});
CellIcon.displayName = 'CellIcon';
export const Cell = Object.assign(CellRoot, {
    Name: CellName,
    Combobox: CellCombobox,
    Input: CellInput,
    Tag: CellCombobox,
    Icon: CellIcon,
    Value: CellRoot,
});
const TitleRoot = forwardRef(({ children, truncate, ...props }, ref) => {
    return (_jsx("div", { className: classes.title, ...props, ref: ref, children: truncate ? (_jsx("span", { className: classes.titleTruncate, children: children })) : (_jsx(_Fragment, { children: children })) }));
});
TitleRoot.displayName = 'Title';
const TitleRequired = forwardRef(({ ...props }, ref) => {
    return (_jsx("span", { className: classes.titleRequiredSign, ...props, ref: ref, children: "*" }));
});
TitleRequired.displayName = 'TitleRequired';
const TitleErrorDot = forwardRef(({ ...props }, ref) => {
    return _jsx("span", { className: classes.titleErrorDot, ...props, ref: ref });
});
TitleErrorDot.displayName = 'TitleErrorDot';
const TitleBadge = ({ tooltip, align = 'left', type = 'info', ...props }) => {
    return (_jsx(Notification, { mode: 'icon', className: clsx(classes.titleBadge, align === 'right' && classes.titleBadgeRightSide), type: type, ...props, children: tooltip }));
};
export const Title = Object.assign(TitleRoot, {
    Required: TitleRequired,
    ErrorDot: TitleErrorDot,
    Badge: TitleBadge,
});
//# sourceMappingURL=Row.js.map